<template>
    <!-- 预算对象列表 -->
    <vBudgetObjectList :postList="postList" v-if="flag"></vBudgetObjectList>
</template>
<script>
import vBudgetObjectList from '../../listComponent/budget/budgetObjectList/budgetObjectListComponent.vue';
export default {
    name: 'budgetObjectList',
    components: {
        vBudgetObjectList
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                full_name_rid: true,
                full_label_rid: true,
                parent_rid: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                updateBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>